import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Marketplace from "./pages/Marketplace";
import PublicationDetail from "./pages/PublicationDetail";
import SocialPageDetail from "./pages/SocialPageDetail";
import PrintMediaDetail from "./pages/PrintMediaDetail";
import BundleDetail from "./pages/BundleDetail";
import Checkout from "./pages/Checkout";
import SubmitContent from "./pages/SubmitContent";
import TrackOrder from "./pages/TrackOrder";
import MyOrders from "./pages/MyOrders";
import CustomerAuth from "./pages/CustomerAuth";
import Insights from "./pages/Insights";
import InsightDetail from "./pages/InsightDetail";
import PartnerApply from "./pages/PartnerApply";
import PartnerDashboard from "./pages/PartnerDashboard";
// Service Landing Pages
import DigitalPR from "./pages/services/DigitalPR";
import SocialMedia from "./pages/services/SocialMedia";
import PrintMedia from "./pages/services/PrintMedia";
import Bundles from "./pages/services/Bundles";
// Admin Pages
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPublications from "./pages/admin/AdminPublications";
import AdminPublicationForm from "./pages/admin/AdminPublicationForm";
import AdminPackages from "./pages/admin/AdminPackages";
import AdminPackageForm from "./pages/admin/AdminPackageForm";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminSiteSettings from "./pages/admin/AdminSiteSettings";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminFAQs from "./pages/admin/AdminFAQs";
import AdminWebhookConfig from "./pages/admin/AdminWebhookConfig";
import AdminAnalytics from "./pages/admin/AdminAnalytics";
import AdminBlogs from "./pages/admin/AdminBlogs";
import AdminBlogForm from "./pages/admin/AdminBlogForm";
import AdminSocialPages from "./pages/admin/AdminSocialPages";
import AdminSocialPageForm from "./pages/admin/AdminSocialPageForm";
import AdminPrintMedia from "./pages/admin/AdminPrintMedia";
import AdminPrintMediaForm from "./pages/admin/AdminPrintMediaForm";
import AdminBundles from "./pages/admin/AdminBundles";
import AdminBundleForm from "./pages/admin/AdminBundleForm";
import AdminPartners from "./pages/admin/AdminPartners";
import AdminEmailCampaigns from "./pages/admin/AdminEmailCampaigns";
import AdminCampaignForm from "./pages/admin/AdminCampaignForm";
import AdminInventory from "./pages/admin/AdminInventory";
import AdminVendors from "./pages/admin/AdminVendors";
import AdminRevenue from "./pages/admin/AdminRevenue";
import Unsubscribe from "./pages/Unsubscribe";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/marketplace" element={<Marketplace />} />
          {/* Service Landing Pages */}
          <Route path="/services/digital-pr" element={<DigitalPR />} />
          <Route path="/services/social-media" element={<SocialMedia />} />
          <Route path="/services/print-media" element={<PrintMedia />} />
          <Route path="/services/bundles" element={<Bundles />} />
          {/* Detail Pages */}
          <Route path="/publication/:id" element={<PublicationDetail />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/login" element={<CustomerAuth />} />
          <Route path="/register" element={<CustomerAuth />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<InsightDetail />} />
          <Route path="/social-page/:id" element={<SocialPageDetail />} />
          <Route path="/print-media/:id" element={<PrintMediaDetail />} />
          <Route path="/bundle/:slug" element={<BundleDetail />} />
          <Route path="/my-orders" element={<MyOrders />} />
          <Route path="/order/:orderId/submit" element={<SubmitContent />} />
          <Route path="/order/:orderId" element={<TrackOrder />} />
          <Route path="/partner/apply" element={<PartnerApply />} />
          <Route path="/partner/dashboard" element={<PartnerDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/partners" element={<AdminPartners />} />
          <Route path="/admin/publications" element={<AdminPublications />} />
          <Route path="/admin/publications/create" element={<AdminPublicationForm />} />
          <Route path="/admin/publications/edit/:id" element={<AdminPublicationForm />} />
          <Route path="/admin/packages" element={<AdminPackages />} />
          <Route path="/admin/packages/create" element={<AdminPackageForm />} />
          <Route path="/admin/packages/edit/:id" element={<AdminPackageForm />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/customers" element={<AdminCustomers />} />
          <Route path="/admin/webhook" element={<AdminWebhookConfig />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="/admin/site-settings" element={<AdminSiteSettings />} />
          <Route path="/admin/testimonials" element={<AdminTestimonials />} />
          <Route path="/admin/faqs" element={<AdminFAQs />} />
          <Route path="/admin/blogs" element={<AdminBlogs />} />
          <Route path="/admin/blogs/create" element={<AdminBlogForm />} />
          <Route path="/admin/blogs/edit/:id" element={<AdminBlogForm />} />
          <Route path="/admin/social-pages" element={<AdminSocialPages />} />
          <Route path="/admin/social-pages/new" element={<AdminSocialPageForm />} />
          <Route path="/admin/social-pages/:id/edit" element={<AdminSocialPageForm />} />
          <Route path="/admin/print-media" element={<AdminPrintMedia />} />
          <Route path="/admin/print-media/new" element={<AdminPrintMediaForm />} />
          <Route path="/admin/print-media/:id/edit" element={<AdminPrintMediaForm />} />
          <Route path="/admin/bundles" element={<AdminBundles />} />
          <Route path="/admin/bundles/new" element={<AdminBundleForm />} />
          <Route path="/admin/bundles/:id/edit" element={<AdminBundleForm />} />
          <Route path="/admin/campaigns" element={<AdminEmailCampaigns />} />
          <Route path="/admin/campaigns/new" element={<AdminCampaignForm />} />
          <Route path="/admin/campaigns/:id" element={<AdminCampaignForm />} />
          <Route path="/admin/campaigns/:id/edit" element={<AdminCampaignForm />} />
          <Route path="/admin/inventory" element={<AdminInventory />} />
          <Route path="/admin/vendors" element={<AdminVendors />} />
          <Route path="/admin/revenue" element={<AdminRevenue />} />
          <Route path="/unsubscribe" element={<Unsubscribe />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/refund" element={<Refund />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;